import requests from "./httpService";
const ChannelPartnerServices = {
  getAllChannelPartner: async (body) => {
    return requests.get('/channelPartnerform/getallchanelpartnerform');
  },

  addChannelPartner: async (body) => {
    return requests.post(`/channelPartnerform/createchannelpartnerfeed`, body);
  },

  getChannelById: async (id) => {
    return requests.get(`/channelPartnerform//${id}`);
  },
};

export default ChannelPartnerServices;
